<template>
	<el-dialog width="600px" :visible.sync="centerDialogVisible" center :close-on-click-modal="false" @close="close">
		<div slot="title" class="flex-row-align-center ml-28 mt-28 pos-rela" style="z-index: 300">
			<div class="color-p-4 fz-24 yx-pingfang-semibold">{{ notice.title }}</div>
			<div class="ml-4 fz-24 yx-pingfang-semibold" v-if="notice.type === 1">· 全新上线！</div>
		</div>
		<div>
			<div class="pl-32 context">{{ notice.context }}</div>
			<div slot="footer" class="dialog-footer mt-28">
				<el-button size="medium" type="primary" v-if="notice.url" @click="jump">前往查看</el-button>
				<el-button size="medium" v-else @click="close">我知道了</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import { popRead } from '@/api/home';

export default {
	data() {
		return {
			centerDialogVisible: false,
			notice: {},
		};
	},
	methods: {
		show(data) {
			// 正在读忽略
			if (this.centerDialogVisible === true) {
				return;
			}
			this.notice = data;
			this.centerDialogVisible = true;
		},
		async jump() {
			this.centerDialogVisible = false;
			const { type, taskTime, isRefresh, taskTimeEnd } = this.notice;
			await popRead({ type, taskTime, taskEndTime: taskTimeEnd });
			if (this.notice.url.indexOf('http') > -1) {
				window.open(this.notice.url, '_blank');
			} else {
				window.open(`${location.protocol}//${this.notice.url}`, '_blank');
			}
			// 是否强制刷新 0-是 1-否 默认1
			if (!isRefresh) window.location.reload();
		},
		async close() {
			this.centerDialogVisible = false;
			const { type, taskTime, isRefresh, taskTimeEnd } = this.notice;
			await popRead({ type, taskTime, taskEndTime: taskTimeEnd });
			// 是否强制刷新 0-是 1-否 默认1
			if (!isRefresh) window.location.reload();
		},
	},
};
</script>

<style lang="less" scoped>
.el-dialog__wrapper /deep/ .el-dialog {
	background: linear-gradient(180deg, #f2f9ff 0%, #d4eaff 100%);
	box-sizing: border-box;
	overflow: hidden;
	border-radius: 16px;
	position: relative;
	&::before {
		content: '';
		background-image: url('~@/assets/public/notice-bg-upperLeft.png');
		background-size: contain;
		position: absolute;
		top: 0;
		left: 0;
		width: 50px;
		height: 50px;
	}
	&::after {
		content: '';
		background-image: url('~@/assets/public/notice-bg-lowerRight.png');
		background-size: contain;
		position: absolute;
		bottom: 0;
		right: 0;
		width: 151px;
		height: 106px;
	}
}
::v-deep .el-dialog__body {
	padding-top: 10px !important;
}
/deep/.el-button {
	border-radius: 8px;
	padding-top: 12px;
	padding-bottom: 12px;
}
.dialog-footer {
	position: relative;
	box-sizing: border-box;
	padding: 0 32px 32px;
	width: 100%;
	display: flex;
	background: transparent;

	button:first-of-type {
		background-color: @color-b4;
		color: @color-white;
	}

	button:nth-child(2) {
		color: @color-b4;
		border: 1px solid @color-b4;
	}
}
.context {
	max-height: 110px;
	white-space: pre-wrap;
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 6px;
	}
	&::-webkit-scrollbar-thumb {
		height: 26px;
		border-radius: 3px;
		background-color: #b3b9c5;
	}
}
</style>
